module.exports = __webpack_public_path__ + "img/phone.a808a327.jpg";